(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ic-aura-catalog"]) return;
  try {
    
(() => {
  const initializeCatalogs = (scope = document) => {
    scope.querySelectorAll('.ic-catalog').forEach(catalog => {
      if (catalog.dataset.icFiltersBound) return;
      const details = catalog.querySelector('.ic-catalog__filter-panel');
      const form = catalog.querySelector('.ic-catalog__filter-form');
      const dialog = catalog.querySelector('.ic-catalog__dialog');
      if (!details || !form || !dialog || typeof dialog.showModal !== 'function') return;
      catalog.dataset.icFiltersBound = 'true';
      const tools = catalog.querySelector('[data-ic-catalog-mobile-tools]');
      const openButton = catalog.querySelector('[data-ic-catalog-filter-open]');
      const closeButton = catalog.querySelector('[data-ic-catalog-filter-close]');
      const clearButton = catalog.querySelector('[data-ic-catalog-clear]');
      const sortLabel = form.querySelector('.ic-catalog__sort');
      const sortSelect = sortLabel.querySelector('select');
      const sortParent = sortLabel.parentNode;
      const sortNext = sortLabel.nextSibling;
      const mobile = window.matchMedia('(max-width: 749px)');
      const syncLayout = () => {
        if (mobile.matches) {
          catalog.querySelector('[data-ic-catalog-filter-host]').append(form);
          catalog.querySelector('[data-ic-catalog-sort-host]').append(sortLabel);
          tools.hidden = false;
          clearButton.hidden = false;
          details.hidden = true;
          catalog.dataset.icMobileFilters = 'true';
        } else {
          if (dialog.open) dialog.close();
          sortParent.insertBefore(sortLabel, sortNext);
          details.append(form);
          tools.hidden = true;
          clearButton.hidden = true;
          details.hidden = false;
          delete catalog.dataset.icMobileFilters;
        }
      };
      openButton.addEventListener('click', () => { if (!dialog.open) dialog.showModal(); });
      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        if (catalog.isConnected) (mobile.matches ? openButton : details.querySelector('summary')).focus({ preventScroll: true });
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      clearButton.addEventListener('click', () => {
        form.querySelectorAll('.ic-catalog__filter-groups input').forEach(input => {
          if (input.type === 'checkbox' || input.type === 'radio') input.checked = false;
          else input.value = '';
        });
      });
      sortSelect.addEventListener('change', () => {
        if (!mobile.matches) return;
        if (!form.checkValidity()) {
          if (!dialog.open) dialog.showModal();
          form.reportValidity();
          return;
        }
        form.requestSubmit();
      });
      mobile.addEventListener('change', syncLayout);
      syncLayout();
      const unload = event => {
        if (!event.target.contains(catalog)) return;
        mobile.removeEventListener('change', syncLayout);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  };
  initializeCatalogs();
  document.addEventListener('shopify:section:load', event => initializeCatalogs(event.target));
})();

(() => {
  const initializePagination = (scope = document) => {
    if (!window.fetch || !window.DOMParser || !window.AbortController) return;
    scope.querySelectorAll('.ic-catalog').forEach(catalog => {
      if (catalog.dataset.icMoreBound) return;
      const grid = catalog.querySelector('[data-ic-catalog-grid]');
      const more = catalog.querySelector('[data-ic-catalog-more]');
      const button = more?.querySelector('[data-ic-catalog-load-more]');
      if (!grid || !more || !button) return;
      const viewed = more.querySelector('[data-ic-catalog-viewed]');
      const progress = more.querySelector('[data-ic-catalog-progress]');
      const status = more.querySelector('[data-ic-catalog-load-status]');
      const pagination = more.querySelector('[data-ic-catalog-pagination]');
      const pageParam = more.dataset.pageParam;
      let currentPage = Number(more.dataset.page);
      const keepPagination = currentPage > 1;
      let next = more.dataset.next;
      let pending = false;
      let controller;
      if (!Number.isInteger(currentPage) || currentPage < 1 || !pageParam || !viewed || !progress || !status) return;
      const pageURL = new URL(location.href);
      const navigationURL = raw => {
        const url = new URL(raw, pageURL);
        if (url.origin !== pageURL.origin || url.pathname !== pageURL.pathname) throw new Error('Invalid catalog URL');
        if (pageURL.searchParams.has('preview_theme_id') && !url.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', pageURL.searchParams.get('preview_theme_id'));
        url.searchParams.delete('sections');
        url.searchParams.delete('section_id');
        url.hash = '';
        return url;
      };
      const nextURL = (raw, page) => {
        const url = navigationURL(raw);
        if (Number(url.searchParams.get(pageParam)) !== page + 1) throw new Error('Invalid next page');
        return url;
      };
      const cardsIn = container => [...container.children].filter(node => node.matches('.ic-card, .ic-catalog__text-result'));
      const cardKey = card => {
        const link = card.matches('a') ? card : card.querySelector('.ic-card-media[href]');
        if (!link) throw new Error('Missing result link');
        const url = new URL(link.getAttribute('href'), pageURL);
        if (url.origin !== pageURL.origin) throw new Error('Invalid result link');
        return url.pathname;
      };
      try { if (next) nextURL(next, currentPage); } catch { return; }
      catalog.dataset.icMoreBound = 'true';
      button.hidden = !next;
      if (pagination) pagination.hidden = Boolean(next) && !keepPagination;
      button.addEventListener('click', async () => {
        if (pending || !next) return;
        pending = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        grid.setAttribute('aria-busy', 'true');
        status.textContent = more.dataset.loadingLabel;
        controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          const url = nextURL(next, currentPage);
          url.searchParams.set('section_id', more.dataset.sectionId);
          const response = await fetch(url.href, { credentials: 'same-origin', redirect: 'error', headers: { Accept: 'text/html' }, signal: controller.signal });
          if (!response.ok) throw new Error('Page request failed');
          const html = await response.text();
          if (!catalog.isConnected) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const incomingCatalog = doc.getElementById(catalog.id);
          const incomingGrid = incomingCatalog?.querySelector('[data-ic-catalog-grid]');
          const incomingMore = incomingCatalog?.querySelector('[data-ic-catalog-more]');
          const incomingPage = Number(incomingMore?.dataset.page);
          const total = Number(incomingMore?.dataset.total);
          if (!incomingGrid || !incomingMore || incomingMore.dataset.pageParam !== pageParam || incomingPage !== currentPage + 1 || !Number.isInteger(total) || total < 1) throw new Error('Invalid catalog response');
          const following = incomingMore.dataset.next || '';
          if (following) nextURL(following, incomingPage);
          const known = new Set(cardsIn(grid).map(cardKey));
          const incomingCards = cardsIn(incomingGrid).filter(card => {
            const key = cardKey(card);
            if (known.has(key)) return false;
            known.add(key);
            return true;
          });
          if (!incomingCards.length || known.size > total) throw new Error('No new results');
          const newIds = new Set();
          incomingCards.forEach(card => {
            const nodes = card.id ? [card, ...card.querySelectorAll('[id]')] : [...card.querySelectorAll('[id]')];
            nodes.forEach(node => {
              if (document.getElementById(node.id) || newIds.has(node.id)) throw new Error('Duplicate result identifiers');
              newIds.add(node.id);
            });
          });
          const incomingPagination = incomingMore.querySelector('[data-ic-catalog-pagination]');
          incomingPagination?.querySelectorAll('a[href]').forEach(link => { link.href = navigationURL(link.getAttribute('href')).href; });
          const focused = document.activeElement === button;
          const added = incomingCards.map(card => document.importNode(card, true));
          grid.append(...added);
          currentPage = incomingPage;
          next = following;
          more.dataset.page = String(currentPage);
          more.dataset.next = next;
          more.dataset.total = String(total);
          const shown = cardsIn(grid).length;
          viewed.textContent = more.dataset.viewedLabel.replaceAll('__VIEWED__', String(shown)).replaceAll('__TOTAL__', String(total));
          progress.max = total;
          progress.value = shown;
          if (pagination) {
            pagination.innerHTML = incomingPagination?.innerHTML || '';
            pagination.hidden = !keepPagination || !incomingPagination;
          }
          button.hidden = !next;
          status.textContent = more.dataset.loadedLabel.replaceAll('__COUNT__', String(added.length)) + ' ' + viewed.textContent;
          document.dispatchEvent(new CustomEvent('ic:products:updated', { detail: { sectionId: more.dataset.sectionId, addedCount: added.length } }));
          if (focused) (added[0].matches('a[href]') ? added[0] : added[0].querySelector('a[href]'))?.focus({ preventScroll: true });
        } catch {
          if (catalog.isConnected) {
            status.textContent = more.dataset.errorLabel;
            if (pagination) pagination.hidden = false;
          }
        } finally {
          clearTimeout(timeout);
          pending = false;
          button.disabled = false;
          button.removeAttribute('aria-busy');
          grid.removeAttribute('aria-busy');
        }
      });
      const unload = event => {
        if (!event.target.contains(catalog)) return;
        controller?.abort();
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  };
  initializePagination();
  document.addEventListener('shopify:section:load', event => initializePagination(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ic-aura-footer"]) return;
  try {
    
if (!customElements.get('ic-footer-navigation')) {
  customElements.define('ic-footer-navigation', class extends HTMLElement {
    connectedCallback() {
      this.groups = Array.from(this.querySelectorAll('.ic-footer-group'));
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.syncGroups = () => {
        this.groups.forEach(group => {
          const summary = group.querySelector('summary');
          if (this.mobile.matches && group.contains(document.activeElement) && document.activeElement !== summary) summary.focus();
          group.open = !this.mobile.matches;
          if (this.mobile.matches) { summary.removeAttribute('tabindex'); summary.removeAttribute('aria-disabled'); }
          else { summary.setAttribute('tabindex', '-1'); summary.setAttribute('aria-disabled', 'true'); }
        });
      };
      this.onSummaryClick = event => { if (!this.mobile.matches && event.target.closest('.ic-footer-group > summary')) event.preventDefault(); };
      this.syncGroups(); this.dataset.enhanced = 'true';
      this.mobile.addEventListener('change', this.syncGroups); this.addEventListener('click', this.onSummaryClick);
    }
    disconnectedCallback() { this.mobile?.removeEventListener('change', this.syncGroups); this.removeEventListener('click', this.onSummaryClick); }
  });
}
if (!customElements.get('ic-footer-localization')) {
  customElements.define('ic-footer-localization', class extends HTMLElement {
    connectedCallback() {
      this.onCountryChange = event => {
        if (!event.target.matches('select[name="country_code"]')) return;
        const form = event.target.form;
        if (form) {
          if (typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();
        }
      };
      this.addEventListener('change', this.onCountryChange);
    }
    disconnectedCallback() { this.removeEventListener('change', this.onCountryChange); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ic-aura-page"]) return;
  try {
    
function initializeICContent(root=document){
  root.querySelectorAll('[data-ic-support]:not([data-ic-ready])').forEach(section=>{
    section.dataset.icReady='true';
    const home=section.querySelector('[data-ic-contents-home]'),nav=section.querySelector('[data-ic-contents-nav]'),dialog=section.querySelector('dialog'),slot=section.querySelector('[data-ic-contents-slot]'),button=section.querySelector('[data-ic-contents-open]');
    if(!dialog?.showModal)return;
    const mobile=matchMedia('(max-width:749px)');
    function place(){if(dialog.open)dialog.close();(mobile.matches?slot:home).append(nav);button.hidden=!mobile.matches;}
    place();mobile.addEventListener('change',place);
    button.addEventListener('click',()=>dialog.showModal());
    nav.addEventListener('click',event=>{const link=event.target.closest('a[href^="#"]');if(!link)return;const target=section.querySelector(link.getAttribute('href'));if(target?.tagName==='DETAILS')target.open=true;if(dialog.open)dialog.close();});
  });
  root.querySelectorAll('[data-ic-about-body]:not([data-ic-ready])').forEach(body=>{
    body.dataset.icReady='true';
    const headings=[...body.children].filter(node=>node.tagName==='H2');
    if(headings.length<4)return;
    const groups=[];let group=null;
    [...body.childNodes].forEach(node=>{if(node.nodeType===1&&node.tagName==='H2'){group=document.createElement('section');group.className='ic-page-about-section';groups.push(group);}if(group)group.append(node);});
    groups.forEach(group=>body.append(group));
    const intro=groups[0],introCopy=document.createElement('div');intro.classList.add('ic-page-about-intro');[...intro.childNodes].slice(1).forEach(node=>introCopy.append(node));intro.append(introCopy);
    const tabs=document.createElement('div');tabs.className='ic-page-about-tabs';const list=document.createElement('div');list.setAttribute('role','tablist');list.setAttribute('aria-label',body.dataset.tabsLabel);tabs.append(list);intro.after(tabs);
    const panels=groups.slice(1,4),buttons=[];
    panels.forEach((panel,index)=>{const heading=panel.querySelector('h2'),button=document.createElement('button'),base=body.closest('[id]')?.id||'ICAbout';button.type='button';button.id=base+'-tab-'+index;button.textContent=heading.textContent.trim();button.setAttribute('role','tab');button.setAttribute('aria-controls',base+'-panel-'+index);button.setAttribute('aria-selected',String(index===0));button.tabIndex=index===0?0:-1;panel.id=base+'-panel-'+index;panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',button.id);panel.tabIndex=0;panel.hidden=index!==0;buttons.push(button);list.append(button);tabs.append(panel);button.addEventListener('click',()=>select(index));button.addEventListener('keydown',event=>{let next=index;if(event.key==='ArrowRight')next=(index+1)%panels.length;else if(event.key==='ArrowLeft')next=(index+panels.length-1)%panels.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=panels.length-1;else return;event.preventDefault();select(next);buttons[next].focus();});});
    function select(index){buttons.forEach((button,i)=>{button.setAttribute('aria-selected',String(i===index));button.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});}
  });
}
initializeICContent();document.addEventListener('shopify:section:load',event=>initializeICContent(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ic-aura-product"]) return;
  try {
    
  function initializeIcProduct(scope) {
    const roots = scope.matches?.('[data-ic-pdp]') ? [scope] : scope.querySelectorAll('[data-ic-pdp]');
    roots.forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const mediaItems = Array.from(root.querySelectorAll('[data-media-id]'));
      const thumbnails = Array.from(root.querySelectorAll('[data-media-trigger]'));
      const stage = root.querySelector('.ic-pdp__stage');
      const position = root.querySelector('[data-ic-pdp-media-position]');
      const mobile = window.matchMedia('(max-width: 899px)');
      let currentMediaId = (mediaItems.find((item) => item.classList.contains('is-active')) || mediaItems[0])?.dataset.mediaId;
      let galleryFrame;
      const showMedia = (id, align = true) => {
        if (!mediaItems.some((item) => item.dataset.mediaId === String(id))) return;
        currentMediaId = String(id);
        mediaItems.forEach((item) => {
          const active = item.dataset.mediaId === String(id);
          item.hidden = !mobile.matches && !active;
          item.inert = !active;
          item.setAttribute('aria-hidden', String(!active));
          item.classList.toggle('is-active', active);
          if (!active) {
            item.querySelectorAll('video').forEach((video) => video.pause());
            item.querySelectorAll('model-viewer').forEach((model) => model.pause?.());
            item.querySelectorAll('iframe').forEach((frame) => {
              try {
                const origin = new URL(frame.src, window.location.href).origin;
                if (/youtube(-nocookie)?\.com$/.test(new URL(origin).hostname)) frame.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), origin);
                if (/vimeo\.com$/.test(new URL(origin).hostname)) frame.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), origin);
              } catch (_) {}
            });
          }
        });
        thumbnails.forEach((thumb) => {
          if (thumb.dataset.mediaTrigger === String(id)) {
            thumb.setAttribute('aria-current', 'true');
            const row = thumb.parentElement;
            const rowRect = row.getBoundingClientRect();
            const thumbRect = thumb.getBoundingClientRect();
            if (rowRect.width && thumbRect.left < rowRect.left) row.scrollLeft -= rowRect.left - thumbRect.left + 2;
            else if (rowRect.width && thumbRect.right > rowRect.right) row.scrollLeft += thumbRect.right - rowRect.right + 2;
            if (!mobile.matches && rowRect.height && thumbRect.top < rowRect.top) row.scrollTop -= rowRect.top - thumbRect.top + 2;
            else if (!mobile.matches && rowRect.height && thumbRect.bottom > rowRect.bottom) row.scrollTop += thumbRect.bottom - rowRect.bottom + 2;
          } else thumb.removeAttribute('aria-current');
        });
        const index = mediaItems.findIndex((item) => item.dataset.mediaId === String(id));
        if (position) position.textContent = String(index + 1);
        if (mobile.matches && align && stage) {
          const selected = mediaItems[index];
          stage.scrollLeft += selected.getBoundingClientRect().left - stage.getBoundingClientRect().left;
        }
      };
      const syncGalleryLayout = () => {
        root.classList.toggle('is-mobile-gallery', mobile.matches && Boolean(stage));
        if (mobile.matches) stage?.setAttribute('tabindex', '0');
        else {
          stage?.removeAttribute('tabindex');
          if (stage) stage.scrollLeft = 0;
        }
        if (currentMediaId) showMedia(currentMediaId);
      };
      syncGalleryLayout();
      mobile.addEventListener('change', syncGalleryLayout);
      stage?.addEventListener('scroll', () => {
        if (!mobile.matches || !stage.clientWidth) return;
        window.cancelAnimationFrame(galleryFrame);
        galleryFrame = window.requestAnimationFrame(() => {
          const index = Math.max(0, Math.min(mediaItems.length - 1, Math.round(stage.scrollLeft / stage.clientWidth)));
          const id = mediaItems[index]?.dataset.mediaId;
          if (id && id !== currentMediaId) showMedia(id, false);
        });
      }, { passive: true });
      stage?.addEventListener('keydown', (event) => {
        if (!mobile.matches || event.target !== stage || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        const currentIndex = mediaItems.findIndex((item) => item.dataset.mediaId === currentMediaId);
        const nextIndex = Math.max(0, Math.min(mediaItems.length - 1, currentIndex + (event.key === 'ArrowRight' ? 1 : -1)));
        event.preventDefault();
        showMedia(mediaItems[nextIndex].dataset.mediaId);
      });
      thumbnails.forEach((thumb) => thumb.addEventListener('click', (event) => { event.preventDefault(); showMedia(thumb.dataset.mediaTrigger); }));
      root.querySelectorAll('[data-ic-pdp-media-step]').forEach((button) => {
        button.hidden = mediaItems.length < 2;
        button.addEventListener('click', () => {
          const index = mediaItems.findIndex((item) => item.dataset.mediaId === currentMediaId);
          const next = (index + Number(button.dataset.icPdpMediaStep) + mediaItems.length) % mediaItems.length;
          showMedia(mediaItems[next].dataset.mediaId);
        });
      });
      thumbnails.forEach((thumb, index) => thumb.addEventListener('keydown', (event) => {
        const previous = mobile.matches ? 'ArrowLeft' : 'ArrowUp';
        const next = mobile.matches ? 'ArrowRight' : 'ArrowDown';
        if (![previous, next, 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const target = event.key === 'Home' ? 0 : event.key === 'End' ? thumbnails.length - 1 : Math.max(0, Math.min(thumbnails.length - 1, index + (event.key === next ? 1 : -1)));
        showMedia(thumbnails[target].dataset.mediaTrigger);
        thumbnails[target].focus({ preventScroll: true });
      }));

      const variantSelect = root.querySelector('[data-ic-pdp-variant]');
      const editions = Array.from(root.querySelectorAll('[data-ic-pdp-edition]'));
      root.classList.toggle('has-editions', editions.length > 0);
      const optionGroups = Array.from(root.querySelectorAll('[data-ic-pdp-option-group]'));
      const variants = Array.from(variantSelect?.options || []).map((option) => ({
        option,
        values: optionGroups.map((_, index) => option.dataset['option-' + (index + 1)])
      }));
      const groupedOptionsReady = optionGroups.length > 0 && variants.length > 0 && variants.every((variant) => variant.values.every((value) => typeof value === 'string' && value.length > 0));
      root.classList.toggle('has-option-groups', groupedOptionsReady);
      const syncOptionGroups = () => {
        if (!groupedOptionsReady) return;
        const selected = variants.find((variant) => variant.option.value === variantSelect.value);
        if (!selected) return;
        optionGroups.forEach((group, index) => {
          group.querySelector('[data-ic-pdp-option-current]').textContent = selected.values[index];
          group.querySelectorAll('[data-ic-pdp-option-value]').forEach((radio) => {
            const matches = variants.filter((variant) => variant.values[index] === radio.value && variant.values.slice(0, index).every((value, previous) => value === selected.values[previous]));
            const unavailable = matches.length === 0;
            const soldOut = !unavailable && !matches.some((variant) => variant.option.dataset.available === 'true');
            radio.checked = radio.value === selected.values[index];
            radio.disabled = unavailable;
            radio.closest('.ic-pdp__option-value').classList.toggle('is-sold-out', soldOut);
            radio.parentElement.querySelector('[data-ic-pdp-option-sold]').hidden = !soldOut;
            radio.parentElement.querySelector('[data-ic-pdp-option-unavailable]').hidden = !unavailable;
          });
        });
      };
      const quantity = root.querySelector('input[name="quantity"]');
      const form = root.querySelector('form[data-ic-add]');
      const minus = root.querySelector('[data-ic-pdp-quantity="-1"]');
      const plus = root.querySelector('[data-ic-pdp-quantity="1"]');
      const syncQuantity = (normalize = false) => {
        const min = Number(quantity.min) || 1;
        const step = Math.max(1, Number(quantity.step) || 1);
        const max = quantity.max ? Number(quantity.max) : Infinity;
        const limit = Number.isFinite(max) ? Math.max(min, min + Math.floor((max - min) / step) * step) : Infinity;
        let value = quantity.valueAsNumber;
        if (normalize) {
          if (!Number.isFinite(value)) value = min;
          value = Math.min(limit, Math.max(min, min + Math.floor((value - min) / step) * step));
          quantity.value = String(value);
        }
        minus.disabled = !Number.isFinite(value) || value <= min;
        plus.disabled = Number.isFinite(value) && value >= limit;
      };
      const syncVariant = () => {
        const option = variantSelect?.selectedOptions[0];
        if (!option) return;
        root.querySelectorAll('[data-ic-pdp-price], [data-ic-pdp-sticky-price]').forEach((node) => { node.textContent = option.dataset.price; });
        const compare = root.querySelector('[data-ic-pdp-compare]');
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
        root.querySelector('[data-ic-pdp-sale]').hidden = !option.dataset.compare;
        root.querySelectorAll('[data-ic-pdp-add]').forEach((add) => {
          add.dataset.available = option.dataset.available;
          add.disabled = option.dataset.available !== 'true' || form?.dataset.busy === 'true';
          add.textContent = option.dataset.available === 'true' ? (add.hasAttribute('data-ic-buy-now') ? root.dataset.buyLabel : root.dataset.addLabel) : root.dataset.soldLabel;
        });
        editions.forEach((radio) => { radio.checked = radio.value === option.value; });
        syncOptionGroups();
        const stickyVariant = root.querySelector('[data-ic-pdp-sticky-variant]');
        const edition = editions.find((radio) => radio.checked);
        if (stickyVariant) stickyVariant.textContent = edition?.nextElementSibling?.querySelector('span')?.textContent || option.textContent.replace(' — ' + root.dataset.soldLabel, '');
        const sku = root.querySelector('[data-ic-pdp-sku]');
        if (sku) { sku.textContent = option.dataset.sku || ''; root.querySelector('[data-ic-pdp-sku-row]').hidden = !option.dataset.sku; }
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
        syncQuantity(true);
        const error = root.querySelector('[data-ic-error]');
        if (error) error.textContent = '';
        const stickyError = root.querySelector('[data-ic-sticky-error]');
        if (stickyError) stickyError.textContent = '';
        if (option.dataset.media) showMedia(option.dataset.media);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState(window.history.state, '', url);
      };
      variantSelect?.addEventListener('change', syncVariant);
      editions.forEach((radio) => radio.addEventListener('change', () => {
        if (!radio.checked) return;
        variantSelect.value = radio.value;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      if (groupedOptionsReady) {
        optionGroups.forEach((group, index) => group.addEventListener('change', (event) => {
          const radio = event.target.closest('[data-ic-pdp-option-value]');
          if (!radio || !radio.checked) return;
          if (radio.disabled) { syncOptionGroups(); return; }
          const desired = optionGroups.map((optionGroup) => optionGroup.querySelector('[data-ic-pdp-option-value]:checked')?.value);
          const exact = variants.find((variant) => variant.values.every((value, position) => value === desired[position]));
          const candidates = variants.filter((variant) => variant.values.slice(0, index + 1).every((value, position) => value === desired[position]));
          candidates.sort((a, b) => {
            const availability = Number(b.option.dataset.available === 'true') - Number(a.option.dataset.available === 'true');
            if (availability) return availability;
            const score = (variant) => variant.values.reduce((total, value, position) => total + Number(position > index && value === desired[position]), 0);
            return score(b) - score(a);
          });
          const next = exact || candidates[0];
          if (!next) { syncOptionGroups(); return; }
          variantSelect.value = next.option.value;
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }));
        const initialId = new URL(window.location.href).searchParams.get('variant');
        if (variants.some((variant) => variant.option.value === initialId)) variantSelect.value = initialId;
        syncVariant();
      }
      quantity.addEventListener('input', () => syncQuantity());
      quantity.addEventListener('change', () => syncQuantity(true));
      syncQuantity();
      root.querySelectorAll('[data-ic-pdp-quantity]').forEach((button) => button.addEventListener('click', () => {
        if (Number(button.dataset.icPdpQuantity) > 0) quantity.stepUp();
        else quantity.stepDown();
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }));

      const sticky = root.querySelector('[data-ic-pdp-sticky]');
      const mainAdd = form?.querySelector('[data-ic-pdp-add]');
      let purchaseReached = false;
      let stickyFrame;
      const updateSticky = () => {
        if (!mainAdd || !sticky) return;
        const rect = mainAdd.getBoundingClientRect();
        const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ic-header-height')) || 0;
        if (rect.top < window.innerHeight - 24) purchaseReached = true;
        const visible = rect.bottom > headerHeight + 8 && rect.top < window.innerHeight;
        root.classList.toggle('is-purchase-visible', mobile.matches && visible);
        const show = mobile.matches && purchaseReached && !visible;
        sticky.hidden = !show;
        sticky.classList.toggle('is-visible', show);
      };
      const scheduleSticky = () => {
        window.cancelAnimationFrame(stickyFrame);
        stickyFrame = window.requestAnimationFrame(updateSticky);
      };
      window.addEventListener('scroll', scheduleSticky, { passive: true });
      window.addEventListener('resize', scheduleSticky);
      mobile.addEventListener('change', scheduleSticky);
      updateSticky();
      const stickyResize = 'ResizeObserver' in window && sticky ? new ResizeObserver(() => {
        const height = Math.ceil(sticky.getBoundingClientRect().height);
        if (height > 0 && mobile.matches) document.documentElement.style.setProperty('--ic-pdp-sticky-height', height + 'px');
        else document.documentElement.style.removeProperty('--ic-pdp-sticky-height');
      }) : null;
      stickyResize?.observe(sticky);
      const unload = (event) => {
        if (!event.target.contains(root)) return;
        window.cancelAnimationFrame(galleryFrame);
        window.cancelAnimationFrame(stickyFrame);
        window.removeEventListener('scroll', scheduleSticky);
        window.removeEventListener('resize', scheduleSticky);
        mobile.removeEventListener('change', syncGalleryLayout);
        mobile.removeEventListener('change', scheduleSticky);
        stickyResize?.disconnect();
        document.documentElement.style.removeProperty('--ic-pdp-sticky-height');
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  initializeIcProduct(document);
  document.addEventListener('shopify:section:load', (event) => initializeIcProduct(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ic-aura-quiz"] && !Shopify.designMode) return;
  try {
    
(() => {
  const bind = (scope = document) => scope.querySelectorAll('[data-ic-finder]').forEach(section => {
    if (section.dataset.icBound) return;
    section.dataset.icBound = 'true';
    const form = section.querySelector('form');
    const steps = [...section.querySelectorAll('[data-ic-finder-step]')];
    const back = section.querySelector('[data-ic-finder-back]');
    const next = section.querySelector('[data-ic-finder-next]');
    const error = section.querySelector('[data-ic-finder-error]');
    const progress = section.querySelector('.ic-finder-progress');
    const result = section.querySelector('[data-ic-finder-results]');
    let step = 0;
    form.noValidate = true;
    const show = index => {
      step = index; steps.forEach((panel, i) => panel.hidden = i !== step);
      back.hidden = step === 0;
      next.textContent = step === 0 ? 'Continue' : 'See my matches';
      section.querySelector('[data-ic-finder-step-label]').textContent = `${step + 1} of 2`;
      section.querySelector('[data-ic-finder-bar]').style.width = `${(step + 1) * 50}%`;
      const title = steps[step].querySelector('legend'); title.tabIndex = -1; title.focus({ preventScroll: true });
    };
    form.addEventListener('submit', event => {
      event.preventDefault(); error.textContent = '';
      if (!form.querySelector('input[name="interest"]:checked')) { error.textContent = 'Choose one option to continue.'; return; }
      if (step === 0) { show(1); return; }
      const interest = new FormData(form).get('interest'); const budget = new FormData(form).get('budget');
      let visible = 0;
      section.querySelectorAll('[data-ic-finder-product]').forEach(card => {
        const price = Number(card.dataset.price);
        const matches = (interest === 'all' || card.dataset.collections.split(' ').includes(interest)) && (budget === 'any' || (budget === 'under' ? price < 10000 : price >= 10000));
        card.hidden = !matches || visible >= 4; if (!card.hidden) visible++;
      });
      form.hidden = true; progress.hidden = true; result.hidden = false; section.classList.add('is-results');
      section.querySelector('[data-ic-finder-empty]').hidden = visible > 0;
      const heading = result.querySelector('h2'); heading.tabIndex = -1; heading.focus({ preventScroll: true });
    });
    back.addEventListener('click', () => show(0));
    section.querySelector('[data-ic-finder-restart]').addEventListener('click', () => { form.reset(); section.classList.remove('is-results'); form.hidden = false; progress.hidden = false; result.hidden = true; error.textContent = ''; show(0); });
  });
  bind(); document.addEventListener('shopify:section:load', event => bind(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
